import { createReducer } from 'redux-create-reducer'

import {
  SHOW_EXTENDED_REVIEW_REQUEST,
  SHOW_EXTENDED_REVIEW_TOGGLE,
  SHOW_EXTENDED_REVIEW_FAIL,
} from 'js/components/searchResults/constants'

const initialState = {
  results: {},
  fetching: null,
  itemsToShow: [],
}

export default createReducer(initialState, {
  [SHOW_EXTENDED_REVIEW_REQUEST](state, { hotelId }) {
    return { ...state, fetching: hotelId }
  },
  [SHOW_EXTENDED_REVIEW_TOGGLE](state, { response, hotelId }) {
    return {
      ...state,
      results: { ...state.results, ...response },
      fetching: null,
      itemsToShow: state.itemsToShow.find(i => i === hotelId)
        ? state.itemsToShow.filter(i => i !== hotelId)
        : [...state.itemsToShow, hotelId],
    }
  },
  [SHOW_EXTENDED_REVIEW_FAIL](state, { error }) {
    return { ...state, error }
  },
})
